import * as React from 'react';
import { Name, Describes } from '../../Profile/ProfileFields';
import { styles, promptSpacing } from './Styles';

export default ({relationship, firstName}) => (
	<fieldset className={styles.fieldset}>
	<legend className={styles.legend}>Demographics</legend>
	<div>
  <div style={{display: 'flex', 'flex-direction': 'column'}}>
	<span style={promptSpacing}>Who does this profile describe?</span>
	<Name />
	</div>
	{firstName.length > 0 && (
		<div style={{display: 'flex', 'flex-direction': 'column'}}>
			<span style={promptSpacing}>What is your relation to <b>{firstName}</b>? </span>
			<Describes firstName={firstName} />
		</div>
	)}
	</div>
							</fieldset>
);



// WEBPACK FOOTER //
// ./src/app/containers/Wizard/Pages/Demographics.tsx